import http, {RequestOptions, noContent, unwrap} from "@/api/http";
import {AdminSettingsDto, EventDto, NextFireTimeDto, Page, WebhookDto} from "@/api/types";

/** `GET /api/admin/settings` (#22, admin) */
export const getAdminSettings = (options?: RequestOptions): Promise<AdminSettingsDto> =>
    http.get<AdminSettingsDto>("/admin/settings", options).then(unwrap);

/** `PUT /api/admin/settings` (#23, admin). Resolves with the stored settings. */
export const saveAdminSettings = (input: AdminSettingsDto, options?: RequestOptions): Promise<AdminSettingsDto> =>
    http.put<AdminSettingsDto>("/admin/settings", input, options).then(unwrap);

/** `GET /api/admin/webhook` (#24, admin): whether the Shopify orders webhook exists. Costs a Shopify round trip. */
export const getWebhook = (options?: RequestOptions): Promise<WebhookDto> =>
    http.get<WebhookDto>("/admin/webhook", options).then(unwrap);

/** `PUT /api/admin/webhook` (#24, admin): creates (`true`) or deletes (`false`) the webhook. Idempotent. */
export const setWebhook = (enabled: boolean, options?: RequestOptions): Promise<WebhookDto> =>
    http.put<WebhookDto>("/admin/webhook", {enabled}, options).then(unwrap);

/**
 * `POST /api/admin/collections/refresh` (#25, admin). 202. Sends `{}` as JSON because the endpoint requires
 * `Content-Type: application/json` and axios drops the header when there is no body.
 */
export const refreshCollections = (options?: RequestOptions): Promise<void> =>
    http.post("/admin/collections/refresh", {}, options).then(noContent);

/** `GET /api/admin/jobs/next-fire-time?name=` (#26, admin), e.g. `"Summary emails"`. `nextFireTime` is `null` when there is none. */
export const getNextFireTime = (name: string, options?: RequestOptions): Promise<NextFireTimeDto> =>
    http.get<NextFireTimeDto>("/admin/jobs/next-fire-time", {...options, params: {name}}).then(unwrap);

export interface ListEventsParams {
    /** Zero-based. */
    page?: number;
    /** At most 100. */
    size?: number;
}

/** `GET /api/admin/events?page=&size=` (#27, admin): newest first; `total` is the row count. */
export const listEvents = (params: ListEventsParams = {}, options?: RequestOptions): Promise<Page<EventDto>> =>
    http.get<Page<EventDto>>("/admin/events", {...options, params}).then(unwrap);
